/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { CertificadoRespuesta, CertificadoAsignadoRequest } from './../_models/certificados';
import { CertificadoPendiente, CertificadoAsignado, Item } from './../_models/certificados';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CertificadoService {

  public liquidacion: EventEmitter<string> = new EventEmitter<string>();
  public asignacion: EventEmitter<any> = new EventEmitter<any>();
  public detalle: EventEmitter<{resp: CertificadoRespuesta, cert: CertificadoAsignado}> = new EventEmitter<{resp: CertificadoRespuesta, cert: CertificadoAsignado}>();
  public certConfirmado: EventEmitter<{resp: CertificadoRespuesta, cert: CertificadoAsignado}> = new EventEmitter<{resp: CertificadoRespuesta, cert: CertificadoAsignado}>();
  public certRechazado: EventEmitter<{resp: CertificadoRespuesta, cert: CertificadoAsignado}> = new EventEmitter<{resp: CertificadoRespuesta, cert: CertificadoAsignado}>();
  public pendientes: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public asignados: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public confirmados: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public rechazados: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public tipos: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public entes: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public drogas: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public responsables: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public error_servidor: EventEmitter<CertificadoRespuesta> = new EventEmitter<CertificadoRespuesta>();
  public downloadCertificado: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient) { }

  getTipo() {
    return this.http.get<CertificadoRespuesta>(
      environment.apiUrl + '/api/v1/tiposcertificados'
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.tipos.emit(resp);
    }).catch((resp: CertificadoRespuesta) => {console.log(resp); this.error_servidor.emit(resp)});
  }

  getConfirmados(distribuidora: boolean = false) {
    let url = environment.apiUrl + '/api/v1/certificadosafiliados';
    if(distribuidora) {
      url = environment.apiUrl + '/api/v1/certificadosdistribuidora';
    }
    url += "?estado=C";
    // url += "&CONFIRMACION=>28/05/2020";
    this.http.get<CertificadoRespuesta>(
      url
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.confirmados.emit(resp);
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  getRechazados(distribuidora: boolean = false) {
    let url = environment.apiUrl + '/api/v1/certificadosafiliados';
    if(distribuidora) {
      url = environment.apiUrl + '/api/v1/certificadosdistribuidora';
    }
    url += "?estado=R";
    this.http.get<CertificadoRespuesta>(
      url
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.rechazados.emit(resp);
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  getPendientes(distribuidora: boolean = false) {
    let url = environment.apiUrl + '/api/v1/certificadosafiliados';
    if(distribuidora) {
      url = environment.apiUrl + '/api/v1/certificadosdistribuidora';
    }
    url += "?estado=G";
    // url += "&GENERACION=>28/05/2020";
    this.http.get<CertificadoRespuesta>(
      url
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.pendientes.emit(resp);
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  getAsignados(distribuidora: boolean = false) {
    let url = environment.apiUrl + '/api/v1/certificadosafiliados';
    if(distribuidora) {
      url = environment.apiUrl + '/api/v1/certificadosdistribuidora';
    }
    url += "?estado=A";
    // url += "&ASIGNACION=>28/05/2020";
    this.http.get<CertificadoRespuesta>(
      url
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.asignados.emit(resp);
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  getDetalle(certificado: CertificadoAsignado, distribuidora: boolean = false) {
    let url = environment.apiUrl + '/api/v1/certificadosdistribuidoralote';
    if(distribuidora) {
      url = environment.apiUrl + '/api/v1/certificadosdistribuidoralote';
    }
    url += "?tipo=" + certificado.tipo;
    url += "&certificado=" + certificado.certificado;
    this.http.get<CertificadoRespuesta>(
      url
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.detalle.emit({resp: resp, cert: certificado});
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  getEntes() {
    this.http.get<CertificadoRespuesta>(
      environment.apiUrl + '/api/v1/entes'
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.entes.emit(resp);
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  getResponsables() {
    this.http.get<CertificadoRespuesta>(
      environment.apiUrl + '/api/v1/responsables'
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.responsables.emit(resp);
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  getDrogas() {
    this.http.get<CertificadoRespuesta>(
      environment.apiUrl + '/api/v1/drogas'
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.drogas.emit(resp);
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  liquidar(tipo: number, cantidad: number) {
    let request = {
      "certificados": [{
        "cantidad": cantidad,
        "tipo": tipo
      }]
    };
    this.http.post<CertificadoRespuesta>(
      environment.apiUrl + '/api/v1/certificados',
      request
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.liquidacion.emit(resp.estado);
    }).catch((resp: HttpErrorResponse) => this.error_servidor.emit(resp.error));
  }

  asignar(certificado: CertificadoPendiente, items: Item[], elaboracion: string, vencimiento: string) {
    
    let request = CertificadoAsignadoRequest.getCert(certificado, items, elaboracion, vencimiento);
    let respuesta = {
      certificado: certificado,
      respuesta: "",
      status: ""
    }
    this.http.post<CertificadoRespuesta>(
      environment.apiUrl + '/api/v1/certificadosasignados',
      request
    ).toPromise().then((resp: CertificadoRespuesta) => {
      respuesta.respuesta = resp.estado;
      respuesta.status = resp.statussalida;
      this.asignacion.emit(respuesta);
    }).catch((resp: HttpErrorResponse) => {
      console.log("HttpErrorResponse");
      console.log(resp);
      console.log("error");
      console.log(resp.error);
      // respuesta.respuesta = resp.error.estado;
      respuesta.status = resp.error.statussalida;
      this.asignacion.emit(respuesta);
      this.error_servidor.emit(resp.error);
    });
  }

  download(certificado: CertificadoAsignado) {
    let header = new HttpHeaders({
      'Accept': 'image/jpeg'
    });
    this.http.get(
      environment.apiUrl + certificado.imagen, {
        headers: header,
        responseType: 'blob'
      }
    ).toPromise().then((resp: any) => {
      this.downloadCertificado.emit({resp: resp, cert: certificado});
    }).catch((error)=>{
      // WORKAROUND
      console.log(error);
      // this.downloadCertificado.emit(error.error.text);
    });
  }

  confirmar(certificado: CertificadoAsignado) {
    let request = {
      'tipo': certificado.tipo,
      'certificado': certificado.certificado
    }
    this.http.post<CertificadoRespuesta>(
      environment.apiUrl + '/api/v1/certificadosconfirmados',
      request
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.certConfirmado.emit({resp: resp, cert: certificado});
    }).catch((resp: HttpErrorResponse) => {
      this.error_servidor.emit(resp.error);
    });
  }

  rechazar(certificado: CertificadoAsignado, detalle: string) {
    let request = {
      'tipo': certificado.tipo,
      'certificado': certificado.certificado,
      'motivo': detalle
    }
    this.http.post<CertificadoRespuesta>(
      environment.apiUrl + '/api/v1/certificadosrechazados',
      request
    ).toPromise().then((resp: CertificadoRespuesta) => {
      this.certRechazado.emit({resp: resp, cert: certificado});
    }).catch((resp: HttpErrorResponse) => {
      this.error_servidor.emit(resp.error);
    });
  }

}
